// extracted by mini-css-extract-plugin
export default {"fullWidth":"rp-z","image":"sp-z","lazyLoadPicture":"tp-z","lazyLoadSpinner":"up-z","lazyLoadSpin":"vp-z","lazyLoadImage":"wp-z","hasStyledAspectRatio":"xp-z"};